import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import modal from '#utilities/js/hotkey/modal.js'

export default contract({
    [selectors]: {
        'slot[data-name="hotkey-new"]': array([
            modal
        ]),
    }
})